var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateChatForm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 46,
    viewBox: "0 0 62 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.4411C1 8.43637 1 6.43398 2.08993 4.90436C3.04867 3.55887 4.57847 2.46494 6.46009 1.77938C8.59921 1 11.3995 1 17 1H45C50.6005 1 53.4008 1 55.5399 1.77938C57.4215 2.46494 58.9513 3.55887 59.9101 4.90436C61 6.43398 61 8.43637 61 12.4411V25.3124C61 29.3172 61 31.3196 59.9101 32.8492C58.9513 34.1947 57.4215 35.2886 55.5399 35.9742C53.4008 36.7536 50.6005 36.7536 45 36.7536H36.6125C34.5323 36.7536 33.4922 36.7536 32.4974 36.8996C31.6148 37.0291 30.7607 37.2434 29.9583 37.5365C29.0539 37.8669 28.2417 38.3315 26.6174 39.2607L18.6659 43.8094C17.2789 44.6028 16.5854 44.9995 16.0018 45C15.4942 45.0004 15.0141 44.8354 14.6974 44.5517C14.3333 44.2256 14.3333 43.5905 14.3333 42.3204V36.7536C11.2334 36.7536 9.68347 36.7536 8.41181 36.5099C4.96089 35.8487 2.26541 33.9213 1.34074 31.4536C1 30.5443 1 29.4359 1 27.2193V12.4411Z",
    fill: "#BD23DB",
    stroke: "#BD23DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateChatForm);
export default __webpack_public_path__ + "static/media/create_chat_form.4e79bb76a408ace6aafdda1400f30c50.svg";
export { ForwardRef as ReactComponent };